import { Box, Button } from '@mui/material';
import { useState } from 'react';

import AgLoadingButton from '@components/AgLoadingButton';
import ButtonRow from '@components/ButtonRow';
import {
  TASK_CHOICE_MAPPING_REVERSE,
  TASK_KIND_MAPPING_REVERSE,
  TaskChoice,
  TaskKind,
  arePermissibleTaskChoicesAndKinds,
} from '@/types';
import FilterPanelPartA from './filterPanel/FilterPanelPartA';
import FilterPanelPartB from './filterPanel/FilterPanelPartB';
import FilterPanelPartC from './filterPanel/FilterPanelPartC';
import { DispatchFilterCriteria, FilterCriteria } from './filterCriteriaReducer';

interface FilterPanelContentProps {
  handleApplyFilter: React.MouseEventHandler<HTMLElement>;
  handleSaveFilter: React.MouseEventHandler<HTMLElement>;
  filterCriteria: FilterCriteria;
  dispatchFilterCriteria: DispatchFilterCriteria;
  isDisableApply: boolean;
  isDisableSave: boolean;
  accordionStates: Record<string, boolean>;
  setAccordionStates: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  isApplying: boolean;
  disabled?: boolean;
}

export default function FilterPanelContent({
  handleApplyFilter,
  handleSaveFilter,
  filterCriteria,
  dispatchFilterCriteria,
  isDisableApply,
  isDisableSave,
  accordionStates,
  setAccordionStates,
  isApplying,
  disabled = undefined,
}: FilterPanelContentProps) {
  const [isEventDateFilterInvalid, setIsEventDateFilterInvalid] = useState(false);
  const [isActivityDateFilterInvalid, setIsActivityDateFilterInvalid] = useState(false);
  const [isCallingStatusDateFilterInvalid, setIsCallingStatusDateFilterInvalid] = useState(false);

  const taskChoiceCodes =
    filterCriteria.taskchoices && filterCriteria.taskchoices.length
      ? filterCriteria.taskchoices.map((x) => TASK_CHOICE_MAPPING_REVERSE[x.label])
      : [];
  const taskKindCodes =
    filterCriteria.taskkinds && filterCriteria.taskkinds.length
      ? filterCriteria.taskkinds.map((x) => TASK_KIND_MAPPING_REVERSE[x.label])
      : [];
  const isCampaignTasksInvalid = !arePermissibleTaskChoicesAndKinds(
    taskChoiceCodes as TaskChoice[],
    taskKindCodes as TaskKind[]
  );

  const sectionProps = {
    filterCriteria,
    dispatchFilterCriteria,
    accordionStates,
    setAccordionStates,
    disabled,
  };

  return (
    <>
      <Box sx={{
        borderBottom: "1px solid #0000001f"
      }}>
        <FilterPanelPartA {...sectionProps} />
        <FilterPanelPartB
          {...sectionProps}
          setIsEventDateFilterInvalid={setIsEventDateFilterInvalid}
          setIsActivityDateFilterInvalid={setIsActivityDateFilterInvalid}
        />
        <FilterPanelPartC
          {...sectionProps}
          setIsCallingStatusDateFilterInvalid={setIsCallingStatusDateFilterInvalid}
        />
      </Box>
      <ButtonRow>
        <Button
          variant="outlined"
          disabled={isDisableSave}
          onClick={handleSaveFilter}
          data-testid="save-FilterPanel"
        >
          Save Search
        </Button>

        <AgLoadingButton
          variant="contained"
          onClick={handleApplyFilter}
          disabled={
            isEventDateFilterInvalid ||
            isActivityDateFilterInvalid ||
            isCallingStatusDateFilterInvalid ||
            isDisableApply ||
            isCampaignTasksInvalid
          }
          loading={isApplying}
          data-testid="apply-FilterPanel"
        >
          Apply
        </AgLoadingButton>
      </ButtonRow>
    </>
  );
}
